export function Themes(site, mode = "") {
    let theme = {};

    switch(site) {
        case 'creative':
            switch(mode) {
                case 'blue':
                    theme = {
                        palette: {
                            mode: "light",
                            primary: {
                                main: 'rgba(255, 199, 209)',
                                contrastText: 'rgba(255, 199, 209)',
                            },
                            secondary: {
                                main: '#135D78',
                            },
                            odd: {
                                main: "rgba(255, 199, 209, 0.10)",
                            },
                            background: {
                                default: "#263B47",
                                paper: "#263B47",
                            },
                            border: {
                                main: "#808080",
                            },
                            text: {
                                primary: 'rgba(255, 255, 255, 0.80)',
                                disabled: 'rgba(255, 199, 209, 0.5)',
                            },
                        },
                        typography: {
                            fontFamily: '"Wales Sans Body", "Helvetica Neue", Helvetica, Arial, sans-serif;',
                        },
                    }
                break;
                case 'pink':
                    theme = {
                        palette: {
                            mode: "light",
                            primary: {
                                main: '#1d1d1b',
                                contrastText: '#1d1d1b',
                            },
                            divider: '#1d1d1b',
                            odd: {
                                main: "rgba(38, 59, 71, 0.10)",
                            },
                            secondary: {
                                main: '#1d1d1b',
                            },
                            background: {
                                default: "#ffc7d1",
                                paper: "#ffc7d1",
                            },
                            border: {
                                main: "#808080",
                            },
                            text: {
                                primary: '#1D1D1B',
                                disabled: 'rgba(29,29,27,0.5)',
                            },
                        },
                        typography: {
                            fontFamily: '"Wales Sans Body", "Helvetica Neue", Helvetica, Arial, sans-serif;',
                        },
                    }
                break;
            default:
                theme = {
                    palette: {
                        mode: "light",
                        primary: {
                            main: 'rgba(255, 199, 209)',
                            contrastText: 'rgba(255, 199, 209)',
                        },
                        odd: {
                            main: "rgba(255, 199, 209, .1)", //pink
                        },
                        secondary: {
                            main: '#135D78',
                        },
                        background: {
                            default: "#1d1d1b",
                            paper: "#1d1d1b",
                        },
                        border: {
                            main: "#808080",
                        },
                        text: {
                            primary: 'rgba(255, 255, 255, 0.87)',
                            disabled: 'rgba(255, 199, 209, 0.5)',
                        },
                    },
                    typography: {
                            fontFamily: '"Wales Sans Body", "Helvetica Neue", Helvetica, Arial, sans-serif;',
                    },
                }
            };
            break;
        default:
            theme = {
                palette: {
                    mode: 'light',
                    primary: {
                        main: '#1D1D1B',
                        contrastText: '#1D1D1B',
                    },
                    odd: {
                        main: '#e7eef1',
                    },
                    background: {
                        default: "#fffffff",
                        paper: "#ffffff",
                    },
                    border: {
                        main: "#a4a59c",
                    },
                    text: {
                        primary: '#1D1D1B',
                        secondary: '#1D1D1B',
                        disabled: 'rgba(29, 29, 27, 0.4)',
                    }
                },
                typography: {
                    fontFamily: '"Wales Serif", "Georgia", "Times New Roman", serif',
                }
            }
    };

    return theme;
};
